import React from 'react';
import './style.scss';

const Main: React.FC = ({children}) => {
    return (
        <div className="app-main">
            { children }
        </div>
    )
}

export default Main;
